import {useQuery} from 'react-query';

import api from 'utils/api';

import playlistKeys from './queryKeys';

function useFetchPlaylists(teamId) {
	async function fetchPlaylists() {
		const {list} = await api('get', '/api/playlists', {
			teamId,
		});
		return list;
	}

	const {
		data = [],
		isError,
		isLoading,
	} = useQuery(playlistKeys.playlists(teamId), fetchPlaylists, {
		staleTime: 5 * 60 * 1000,
	});

	return {
		playlists: data,
		isLoading,
		isError,
	};
}

export default useFetchPlaylists;
